import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import Loader from "react-loader-spinner";
import { getComplaintList } from "../store/api/ComplaintsAPI";
import { Table } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
const ComplaintList = () => {
    const dispatch = useDispatch();
    const list = useSelector(state => state.ComplaintsReducer.complaintList);
    const productSerial = useRef();
    const search = () => {
        let serial = productSerial.current.value??' ';
        dispatch(getComplaintList(serial));
    }
    useEffect(() => {
        document.body.classList = "notMain";
    }, []);
    return (
        <div className="container-fluid mt-4">
            <div className="card">
                <div className="card-header headerStyle">لیست شکایات</div>
                <div className="card-body bodyStyle">
                    <div className="form-group" style={{ textAlign: "right" }}>
                        <label>سریال محصول</label>
                        <div>
                            <input type="text" className="form-control" ref={productSerial} style={{ display: "inline-block", width: "50%" }} />
                            <button className="btn btn-primary group-Btn" onClick={search}><Search size={14} /></button>
                        </div>
                    </div>
                    <Table responsive={true} className="mt-2">
                        <thead>
                            <tr>
                                <th style={{ display: "none" }}></th>
                                <th>تاریخ ثبت</th>
                                <th>عنوان</th>
                                {window.innerWidth >= 414 && <th>متن</th>}
                                <th>سریال محصول</th>
                                <th>وضعیت</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list && list === "PENDING" &&
                                <tr>
                                    <td colSpan={6} style={{textAlign:"center"}}>
                                        
                                        <Loader type="BallTriangle" color="red" height={35} width={35} />
                                    </td>
                                </tr>}
                            {list && list !== "PENDING" &&
                                list.map((item, i) => {
                                    return <tr className="resultTableRow" key={i}>
                                        <td style={{ display: "none" }}></td>
                                        <td className="columnForPrint">{item.PCreationDate}</td>
                                        <td className="columnForPrint">{item.Title}</td>
                                        {window.innerWidth >= 414 && <td className="columnForPrint">{item.Body}</td>}
                                        <td className="columnForPrint">{item.ProductSerial}</td>
                                        <td className="columnForPrint" style={{color:"blue"}}>{item.Status}</td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </Table>
                </div>
            </div>


        </div>
    );
}
export default ComplaintList;